'use strict';

export default {
  MEAL: 'meal',
  RECIPE: 'recipe',
  PLAN: 'plan'
};
